import { SVGProps } from 'react'

type PlayIconProps = SVGProps<SVGSVGElement>

const PlayIcon = ({ className, ...props }: PlayIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={16}
    fill="none"
    {...props}
    className={className}
  >
    <path fill="#fff" d="M.528 15.454V.91L13.26 8.182.528 15.454Z" />
  </svg>
)
export default PlayIcon
